define([
    'santa-components',
    'componentsCore',
    'audioCommon',
    'skins',
    'audioPlayer/skins/skins.json'
], function (santaComponents, componentsCore, audioCommon, skinsPackage, skinsJson) {
    'use strict';

    const santaTypes = santaComponents.santaTypesDefinitions;
    const audioPlayerStates = audioCommon.audioPlayerStates;

    /**
     * @class components.AudioPlayer
     * @extends {core.skinBasedComp}
     * @extends {ReactCompositeComponent}
     * @extends {componentsCore.skinInfo}
     * @property {comp.properties} props
     * @extends {core.audioMixin}
     * @property {comp.properties} props
     */
    const audioPlayer = {
        displayName: 'AudioPlayer',
        mixins: [
            componentsCore.mixins.skinBasedComp,
            componentsCore.mixins.skinInfo,
            audioCommon.audioMixin
        ],
        propTypes: {
            compData: santaTypes.Component.compData.isRequired
        },

        getInitialState() {
            this.audioVolume = this.props.compData.volume;

            return {
                $playerState: audioPlayerStates.WAITING
            };
        },

        finishedPlayingAudio() {
            if (this.props.compData.loop) {
                this.playAudio();
            } else {
                this.initiatePause();
            }
        },

        handleAudioPlayerClick() {
            switch (this.state.$playerState) {
                case audioPlayerStates.WAITING:
                case audioPlayerStates.PAUSING:
                    this.initiatePlay();
                    break;
                case audioPlayerStates.PLAYING:
                    this.initiatePause();
                    break;
            }
        },

        getMediaButtonAriaLabel() {
            switch (this.state.$playerState) {
                case audioPlayerStates.WAITING:
                case audioPlayerStates.PAUSING:
                    return 'Play';
                case audioPlayerStates.PLAYING:
                    return 'Pause';
            }
        },

        getSkinProperties() {
            // we need this as member values because of audioMixin,
            // (for example singleAudioPlayer has the "autoplay" value on compProps instead of compData)
            this.audioVolume = this.props.compData.volume;
            this.autoPlay = this.props.compData.autoPlay;

            this.updateAudioObject();
            return {
                '': {
                    role: 'application',
                    'aria-label': `Application, Audio player, ${this.props.compData.originalFileName}`
                },
                'mediaButton': {
                    'aria-label': `${this.getMediaButtonAriaLabel()}, toggle`,
                    onClick: this.handleAudioPlayerClick
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.AudioPlayer', audioPlayer);
    skinsPackage.skinsMap.addBatch(skinsJson);

    return audioPlayer;
});
